import React, { Component } from 'react'
import styled, { css } from 'styled-components'
import rnStyled from 'styled-components/native'
import { Constants } from '@sukiai/components'
import { charcoal, scribeGreen, amwellPrimaryButtonColor } from '@sukiai/components/lib/colors'

import { isAmwellTheme } from '../lib/util'

const { MODALS } = Constants

const Veil = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999999;
`

const ModalContainer = styled.div`
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.2);
  background-color: #f8f9f7;
  width: 500px;
  padding: 20px 20px 10px 20px;
  position: absolute;
  top: 300px;
  z-index: 9999999;
  box-sizing: border-box;
  max-height: 500px;
  ${props => props.isAmwell && css`
    border-radius: 4px;
    background-color: rgb(45,55,64);
    padding: 20px 24px;
    width: 412px;
    max-width: 800px;
    margin: 0px 24px;
  `}
`

const Heading = rnStyled.Text`
  width: 100%;
  font-size: 18px;
  font-weight: 600;
  text-align: ${props => props.type === MODALS.IM_DONE_BYPASS_QA || props.type === MODALS.SCRIPT_DETAILS ? 'center' : 'left'};
  padding-bottom: 30px;
  font-family: 'Open Sans';
  color: ${charcoal};
  ${props => props.isAmwell && css`
    color: #fff;
    font-size: 24px;
    padding: 8px 0px;
  `}
`

const Footer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
`

const ActionButton = rnStyled.TouchableOpacity`
  margin-right: ${props => props.alignleft === 'true'
    ? 'auto'
    : 'none'
  };
  padding: ${props => props.padding || '0px'};
`

const ActionText = styled.div`
  font-family: 'Open Sans';
  padding: ${props => props.padding || '6px 10px 0px 10px'};
  text-transform: ${props => props.allcaps === 'true' ? 'uppercase' : 'none'};
  border-radius: 4px;
  font-weight: 600;
  margin-left: ${props => props.type === MODALS.ICD10_PREVIEW ? '0' : '18px'};
  font-size: 16px;
  cursor: pointer;
  color: ${props => props.disabled === 'true'
    ? '#DCDCDC'
    : scribeGreen
  };
  transition-duration: 0.5s;
  ${props => props.isAmwell && css`
    margin-left: 0px;
    color: ${amwellPrimaryButtonColor};
    font-weight: 700;
  `}
`

class DeleteItemModal extends Component {
  render () {
    const { handleClose, handleDelete, deleteString } = this.props
    const dataCy = this.props['data-cy']

    const isAmwell = isAmwellTheme()
    return (
      <Veil onClick={handleClose}>
        <ModalContainer onClick={e => e.stopPropagation()} isAmwell={isAmwell}>
          <Heading isAmwell={isAmwell}>
            {deleteString}
          </Heading>
          <Footer>
            <ActionButton
              onPress={handleClose}
              alignleft='true'
              padding='12px 0px'
            >
              <ActionText padding='6px 10px 0px 0px' isAmwell={isAmwell}>
                Cancel
              </ActionText>
            </ActionButton>

            <ActionButton
              onPress={handleDelete}
              padding='12px 0px'
            >
              <ActionText data-cy={dataCy} isAmwell={isAmwell}>
                Delete
              </ActionText>
            </ActionButton>
          </Footer>
        </ModalContainer>
      </Veil>
    )
  }
}
export default DeleteItemModal
